import {Component, inject, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {GatewayOpeService} from "src/app/services/ope/gatewayOpe.service";
import {BaseComponentWithDrawer} from "../base-component-with-drawer.component";
import {GlobalModelService} from "../../../services/GlobalModel.service";
import {DeviceTypeOpeService} from "../../../services/ope/deviceTypeOpe.service";
import {GatewayTypeOpeService} from "../../../services/ope/gatewayTypeOpe.service";
import {DeviceOpeService} from "../../../services/ope/deviceOpe.service";
import {SpringRestService} from "@aiknow-srl/aik-ngx-http";
import {DeviceLite, Gateway} from "../../../models/gateway/Gateway";
import {MetricGroup} from "../../../models/device-type/DeviceType";
import {GatewayType} from "../../../models/gateway-type/GatewayType";
import {Device} from "../../../models/device/Device";
import {GetDeviceTypesCB} from "../../../ope/device-type/GetDeviceTypesCB";
import {GetDeviceTypeCB} from "../../../ope/device-type/GetDeviceTypeCB";
import {GetGatewayTypesCB} from "../../../ope/gateway-type/GetGatewayTypesCB";
import {PutGatewayCB} from "../../../ope/gateway/PutGatewayCB";
import {PutGatewayLegacyCB} from "../../../ope/gateway/PutGatewayLegacyCB";
import {DelGatewayCB} from "../../../ope/gateway/DelGatewayCB";
import {GatewayStatusEnum} from "../../../models/gateway/GatewayStatusEnum";
import {DeviceTypeLite} from "../../../models/device-type/DeviceTypeLite";
import {NetConfig} from "../../../models/gateway/NetConfig";
import {ChangePartitionEvent} from "../../../events/ChangePartitionEvent";
import {PartitionSelectionService} from "../../../services/partition/partition-selection.service";
import {EditModeEvent} from "../../../events/EditModeEvent";
import {GetNetInterfacePasswordCB} from "../../../ope/gateway/GetNetInterfacePasswordCB";
import {DeviceAlarmNotificationService} from "../../../services/notification/interfaces/DeviceAlarmNotificationService";
import {NotificationService} from "../../../services/notification/notification.service";
import {
  GatewayAlarmNotificationService
} from "../../../services/notification/interfaces/GatewayAlarmNotificationService";
import {DeviceAlarmStatusEnum} from "../../../models/notification/DeviceAlarmStatus";
import {GatewayAlarmStatusEnum} from "../../../models/notification/GatewayAlarmStatus";
import {
  GatewayWorkflowNotificationService
} from "../../../services/notification/interfaces/GatewayWorkflowNotificationService";
import {WriteOnEdgeOriginTypeEnum} from "src/app/enums/registry/WriteOnEdgeOriginTypeEnum";
import {ProtocolTypeEnum} from "../../../enums/registry/ProtocolTypeEnum";
import {GatewayEditFormComponent} from "./gateway/gateway-edit-form/gateway-edit-form.component";
import {DeviceEditFormComponent} from "./device/device-edit-form/device-edit-form.component";
import {CompareGroupVM, CompareMetricVM} from "../../../models/device/DeviceTemplateCompare";
import {GetDevicePendingConfigCB} from "../../../ope/gateway-pending-config/GetDevicePendingConfigCB";
import {ReadGatewayPendingConfigFallbackCB} from "../../../ope/gateway-pending-config/ReadGatewayPendingConfigFallbackCB";
import {CancelDevicePendingConfigCB} from "../../../ope/gateway-pending-config/CancelDevicePendingConfigCB";
import {GatewayPendingConfigOpeService} from "../../../services/ope/gatewayPendingConfigOpe.service";
import {DeviceDraft, MetricGroupInstanceDraft, MetricInstanceDraft} from "../../../models/device/DeviceDraft";
import {SaveDevicePendingConfigCB} from "../../../ope/gateway-pending-config/SaveDevicePendingConfigCB";
import {
  DeviceDraftDTO,
  MetricGroupInstanceDraftDTO,
  MetricInstanceDraftDTO, Wm2eOriginDTO
} from "../../../ope/gateway-pending-config/GatewayPendingConfigPayloadDTO";
import {getRowKey} from "../../../utils/rowKey";
import * as uuid from "uuid";
import {custom} from "devextreme/ui/dialog";
import {ResetDeviceFromModelCB} from "../../../ope/device/ResetDeviceFromModelCB";
import { GetGatewaysPayloadCB } from "src/app/ope/gateway-pending-config/GetGatewaysPayloadCB";
import { GetGatewayPayloadCB } from "src/app/ope/gateway-pending-config/GetGatewayPayloadCB";
import {ChangeTypeEnum} from "../../../ope/gateway-pending-config/GatewayPendingConfigPayloadDTO";

@Component({
  selector: 'app-gateway-device',
  templateUrl: './gateway-device.component.html',
  styleUrls: ['./gateway-device.component.css', '../../common/drawer-style.css', '../base-component-with-drawer.component.css']
})
export class GatewayDeviceComponent extends BaseComponentWithDrawer implements OnInit, OnDestroy {
  get isEditMode(): boolean {
    return this._isEditMode;
  }

  set isEditMode(value: boolean) {
    this._isEditMode = value;
  }

  gmService: GlobalModelService = inject(GlobalModelService);
  partitionSelection: PartitionSelectionService = inject(PartitionSelectionService);
  gatewayService: GatewayOpeService = inject(GatewayOpeService);
  deviceTypeOpeService: DeviceTypeOpeService = inject(DeviceTypeOpeService);
  gatewayTypeOpeService: GatewayTypeOpeService = inject(GatewayTypeOpeService);
  deviceOpeService: DeviceOpeService = inject(DeviceOpeService);
  gatewayPendingConfigOpeService: GatewayPendingConfigOpeService = inject(GatewayPendingConfigOpeService);


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //                                        DEVICE LOGIC
  //
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  @ViewChild('editGatewayFormComponent', {static: false}) editGatewayFormComponent!: GatewayEditFormComponent;
  @ViewChild('editDeviceFormComponent', {static: false}) editDeviceFormComponent!: DeviceEditFormComponent;
  /**
   * All selected partition gateways
   */
  gateways: Gateway[] = [];
  deviceTypes: DeviceTypeLite[] = [];
  gatewayTypes: GatewayType[] = [];
  get selectedPartitionId(): number | undefined {
    return this.partitionSelection.selectedPartitionId ?? undefined;
  }

  selectedGatewayNetConfig?: NetConfig[];
  /**
   * Copy of selected gateway, storing temporary changes (can roll back to selectedGateway if something goes wrong)
   */
  editedGateway?: Gateway;
  selectedDeviceLite?: DeviceLite;
  selectedDeviceFull?: DeviceDraft;
  editedDeviceFull: DeviceDraft;
  selectedMetricGroup?: MetricGroupInstanceDraft;
  templateCompareVisible: boolean = false;
  /**
   * Enable lateral drawer form when true
   */
  private _isEditMode: boolean = false;
  /**
   * Tab selected gateway-device form (new/edit)
   */
  selectedDeviceTab: number = 0;
  /**
   * True if the gateway-device changed anything in edit gateway-device form
   */
  deviceEdited: boolean = false;
  /**
   * True if new gateway is valid and can be saved
   */
  isNewFormValid: boolean | undefined = false;
  /**
   * True if edited gateway is valid and can be updated
   */
  isEditFormValid: boolean | undefined = false;
  /**
   * Id of the selected gateway in the gateway data grid (selected by clicking on a row)
   */
  selectedRowGateway: any;
  /**
   * Show delete gateway-device form when true
   */
  deletingDevice: boolean = false;
  /**
   * Id of the selected row in metric group data grid
   */
  selectedRowMetricGroup: any;
  /**
   * Id of the selected row in gateway-device data grid
   */
  selectedRowDevice: any;
  /**
   * New gateway object for new gateway form
   */
  newDevice?: DeviceDraft = new DeviceDraft();
  /**
   * Show new gateway-device form
   */
  addDevice: boolean = false;
  /**
   * Id of the selected partition in new gateway form
   */
  selectedRowPartitionNewGatewayForm: any;

  deviceEditTextOptions = {
    valueChangeEvent: 'keyup focusout',
    disabled: !this.isEditMode
  };
  deviceEditTextAreaOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
    autoResizeEnabled: true
  };
  deviceEditNumberOptions: any = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
    value: 0,
    mode: 'number'
  };
  deviceEditCheckBoxOptions = {
    disabled: !this.isEditMode
  };

  /**
   * Tab selected gateway form (new/edit)
   */
  selectedGatewayTab: number = 0;
  /**
   * True if the gateway changed anything in edit gateway form
   */
  gatewayEdited: boolean = false;
  /**
   * Show delete gateway form when true
   */
  deletingGateway: boolean = false;
  /**
   * New gateway object for new gateway form
   */
  newGateway?: Gateway = new Gateway();
  /**
   * Show new gateway form
   */
  addGateway: boolean = false;
  gatewayEditTextOptions = {
    valueChangeEvent: 'keyup focusout',
    disabled: !this.isEditMode
  };
  gatewayEditTextAreaOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
    autoResizeEnabled: true
  };
  gatewayEditNumberOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
    mode: 'number'
  };
  gatewayEditCheckBoxOptions = {
    disabled: !this.isEditMode
  };
  protected be = inject(SpringRestService);
  /**
   * Service used for push notification subscriptions and event handling of devices
   * @protected
   */
  protected deviceAlarmNotificationService: DeviceAlarmNotificationService = inject(NotificationService);
  /**
   * List of ids of subscribed devices to their alarm push notification
   * @protected
   */
  protected subscribedNotificationIdsDevices: number[] = [];
  /**
   * Service used for push notification subscriptions and event handling of gws
   * @protected
   */
  protected gatewayAlarmNotificationService: GatewayAlarmNotificationService = inject(NotificationService);
  /**
   * Service used for push notification subscriptions and event handling of gws
   * @protected
   */
  protected gatewayWorkflowNotificationService: GatewayWorkflowNotificationService = inject(NotificationService);
  /**
   * List of ids of subscribed gw to their alarm push notification
   * * @protected
   */
  protected subscribedAlarmNotificationIdsGateways: number[] = [];
  /**
   * List of ids of subscribed gw to their alarm push notification
   * * @protected
   */
  protected subscribedWorkflowNotificationIdsGateways: number[] = [];
  protected readonly GatewayStatusEnum = GatewayStatusEnum;
  protected readonly DeviceAlarmStatusEnum = DeviceAlarmStatusEnum;
  protected readonly WriteOnEdgeOriginTypeEnum = WriteOnEdgeOriginTypeEnum;

  constructor() {
    super();
    this.editedDeviceFull = new DeviceDraft();

  }

  /**
   * Selected gateway on data grid row click
   */
  private _selectedGateway?: Gateway;

  get selectedGateway(): Gateway | undefined {
    return this._selectedGateway;
  }

  set selectedGateway(selectedGateway: Gateway | undefined) {
    this._selectedGateway = selectedGateway;
    this.deviceAlarmNotificationService.removeDeviceIdsToAlarmNotifications(this.subscribedNotificationIdsDevices);
  }

  /**
   * Show lateral drawer when true
   */
  _isGatewayDrawerOpen = false;

  get isGatewayDrawerOpen(): boolean {
    return this._isGatewayDrawerOpen;
  }

  set isGatewayDrawerOpen(isGatewayDrawerOpen: boolean) {
    this._isGatewayDrawerOpen = isGatewayDrawerOpen;
    this.eventBus.emitEvent(new EditModeEvent(isGatewayDrawerOpen));
  }

  /**
   * Show lateral drawer when true
   */
  _isDeviceOrGatewayDrawerOpen = false;

  get isDeviceOrGatewayDrawerOpen(): boolean {
    return this._isDeviceOrGatewayDrawerOpen;
  }

  set isDeviceOrGatewayDrawerOpen(isDeviceOfGatewayDrawerOpen: boolean) {
    this._isDeviceOrGatewayDrawerOpen = isDeviceOfGatewayDrawerOpen;
    this.eventBus.emitEvent(new EditModeEvent(isDeviceOfGatewayDrawerOpen));
  }

  /**
   * The gateway table drops its non-essential columns while the device drawer is open, to leave
   * room to the device table and the drawer. Desktop only.
   */
  get isGatewayTableCompact(): boolean {
    // Tied to the drawer, not to the row click: shrinking before the device is fetched would show the
    // table change first and the drawer only when the request returns
    return this.isDeviceOrGatewayDrawerOpen && !!this.selectedDeviceFull && !this.isGatewayDrawerOpen
      && !this.isMobile && !this.isSmallScreen;
  }

  // Read from the device list rather than selectedDeviceLite, which keeps the row object from
  // the click and goes stale once the list is refetched (e.g. after a revert).
  get isSelectedDevicePendingDeletion(): boolean {
    const id = this.selectedDeviceLite?.id;
    return this.selectedGateway?.devices?.find(d => d.id === id)?.changeType === ChangeTypeEnum.DELETED;
  }

  // selectDeviceTypeEditorOptions =

  /**
   * Device drawer width, as a fraction of the viewport, while the gateway table is compact.
   * Tune it together with the compact width of app-gateway-table (gateway-device.component.css):
   * the device table's Nome column has to stay uncovered.
   */
  static readonly COMPACT_DRAWER_VIEWPORT_RATIO = 0.58;

  /**
   * Which width setWidthOfDrawerPx() gives the drawer content. Not derived from the open state on
   * purpose: it only changes right before a drawer opens (see prepareDrawerWidth), so the closing
   * animation always runs with the width the drawer was opened with.
   */
  compactDrawerWidth = false;

  /**
   * The drawer panel keeps the width it was first measured with, so when the width changes it has to
   * be re-measured. Done while the drawer is still closed, so the opening animation is not affected.
   */
  private prepareDrawerWidth(compact: boolean) {
    if (this.compactDrawerWidth === compact)
      return;
    this.compactDrawerWidth = compact;
    this.cdr.detectChanges();
    this.drawers?.first?.instance.repaint();
  }

  ngOnInit() {

    super.ngOnInit();
    this.getDeviceTypes();
    this.getGatewayTypes();
    this.getGateways();

    this.subscriptions = [
      this.eventBus.onEvent(ChangePartitionEvent.NAME, () => {
        this.resetGatewayGrid();
        this.resetDeviceGrid();
        this.selectedMetricGroup = undefined;
        this.selectedRowMetricGroup = [];
        this.getGateways();
      }),
      this.deviceAlarmNotificationService.onDeviceStatusChanged(event => {
        if (!!this.selectedGateway && !!this.selectedGateway.devices) {
          let deviceToUpdate = this.selectedGateway?.devices?.find(d => d.id === event.value.deviceId);
          if (deviceToUpdate) {
            deviceToUpdate.alarmStatus = event.value.status
          }
        }
      }),
      this.gatewayAlarmNotificationService.onGatewayStatusChanged(event => {
        let gatewayToUpdate = this.gateways.find(gateway => gateway.id === event.value.gatewayId);
        if (gatewayToUpdate) {
          gatewayToUpdate.online = event.value.status === GatewayAlarmStatusEnum.ONLINE;
        }
        if (this.selectedGateway && this.selectedGateway.id === event.value.gatewayId) {
          this.selectedGateway.online = event.value.status === GatewayAlarmStatusEnum.ONLINE;
        }
        this.cdr.detectChanges();
      }),
      this.gatewayWorkflowNotificationService.onGatewayWorkflowStatusChanged(event => {
        // The notification only carries `status`, not `hasPendingDevice` - but a transition
        // to DEVICES_CONFIGURED means the pending draft was just applied, so the "cancel
        // config" (rollback) button's *ngIf="status !== UPDATING_CONFIG && hasPendingDevice"
        // must be cleared here too, or it keeps showing on stale data.
        const configApplied = event.value.status === GatewayStatusEnum.DEVICES_CONFIGURED;
        let gatewayToUpdate = this.gateways.find(gateway => gateway.id === event.value.gatewayId);
        if (gatewayToUpdate) {
          gatewayToUpdate.status = event.value.status;
          if (configApplied)
            gatewayToUpdate.hasPendingDevice = false;
        }
        if (this.selectedGateway && this.selectedGateway.id === event.value.gatewayId) {
          this.selectedGateway.status = event.value.status;
          if (configApplied)
            this.selectedGateway.hasPendingDevice = false;
        }
        this.cdr.detectChanges();
        // DEVICES_CONFIGURED is the only status reached when the draft goes away (applied, or
        // discarded with "revert all"), i.e. the only one that changes the changeType badges.
        if (configApplied)
          this.refreshGatewayFromServer(event.value.gatewayId);
      })
    ]
  }

  ngOnDestroy() {
    super.ngOnDestroy();

    this.gatewayAlarmNotificationService.removeGatewayIdsToAlarmNotifications(this.subscribedAlarmNotificationIdsGateways);
    this.gatewayWorkflowNotificationService.removeGatewayIdsToWorkflowNotifications(this.subscribedWorkflowNotificationIdsGateways);
    this.deviceAlarmNotificationService.removeDeviceIdsToAlarmNotifications(this.subscribedNotificationIdsDevices);
  }

  /**
   * Get all gateways for a specific partition
   */
  getGateways(newGatewayId?: number, skipGatewayRefresh?: boolean) {

    if (!!this.selectedPartitionId || this.selectedPartitionId === 0) {
      const cb = new GetGatewaysPayloadCB();
      cb.i.partitionId = this.selectedPartitionId;

      this.gatewayPendingConfigOpeService.getGatewaysPayload(cb).then((_) => {

        this.gateways = cb.o.gateways.map(item => ({...item.gateway, changeType: item.status}));

        this.gatewayAlarmNotificationService.removeGatewayIdsToAlarmNotifications(this.subscribedAlarmNotificationIdsGateways);
        this.gatewayWorkflowNotificationService.removeGatewayIdsToWorkflowNotifications(this.subscribedWorkflowNotificationIdsGateways);
        this.subscribedAlarmNotificationIdsGateways = this.gateways.map(g => g.id);
        this.subscribedWorkflowNotificationIdsGateways = this.gateways.map(g => g.id);
        this.gatewayAlarmNotificationService.addGatewayIdsToAlarmNotifications(this.subscribedAlarmNotificationIdsGateways);
        this.gatewayWorkflowNotificationService.addGatewayIdsToWorkflowNotifications(this.subscribedWorkflowNotificationIdsGateways);

        if (!!newGatewayId || newGatewayId === 0) {
          this.selectedGateway = this.gateways.find(g => g.id === newGatewayId);
          this.editedGateway = JSON.parse(JSON.stringify(this.selectedGateway));
          this.selectedRowGateway = [this.selectedGateway!.id];
        }

        if (this.selectedGateway && !skipGatewayRefresh) {
          this.getGateway();
        }


      });
    }
  }

  /**
   * Get a specific gateway
   */
  getGateway(editGatewayDrawer?: boolean) {

    const cb = new GetGatewayPayloadCB();

    cb.i.gatewayId = this.selectedGateway!.id;

    this.gatewayPendingConfigOpeService.getGatewayPayload(cb).then((_) => {

      const gateway: Gateway = {...cb.o.gateway, changeType: cb.o.status};
      this.selectedGateway = gateway;

      this.selectedGatewayNetConfig = this.parseNetworkConfig(gateway.netConfig);

      if (editGatewayDrawer) {
        this.editedGateway = JSON.parse(JSON.stringify(this.selectedGateway));

        this.isDeviceOrGatewayDrawerOpen = false;

        this.prepareDrawerWidth(false);
        this.isGatewayDrawerOpen = true;
      }

      this.refreshGatewayDeviceListAndOpenDevice();
    });


  }


  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  //
  //                                        GATEWAY LOGIC
  //
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  /**
   * Get all gateway-device types
   */
  getDeviceTypes() {
    const cb = new GetDeviceTypesCB();

    this.deviceTypeOpeService.getDeviceTypes(cb).then((_) => {

      this.deviceTypes = cb.o.deviceTypes;


    });
  }


  /**
   * Get all gateway types
   */
  getGatewayTypes() {
    const cb = new GetGatewayTypesCB();

    this.gatewayTypeOpeService.getGatewayTypes(cb).then((_) => {

      this.gatewayTypes = cb.o.gatewayTypes;

    });
  }

  /**
   * Get all devices
   */
  getDevices() {
    const cb = new GetGatewayPayloadCB();

    cb.i.gatewayId = this.selectedGateway!.id;

    this.gatewayPendingConfigOpeService.getGatewayPayload(cb).then((_) => {

      this.selectedGateway = {...cb.o.gateway, changeType: cb.o.status};
      this.selectedGatewayNetConfig = this.parseNetworkConfig(this.selectedGateway.netConfig);

      this.refreshGatewayDeviceListAndOpenDevice();
      this.getGateways(undefined, true);
    });

  }

  /**
   * Devices grid data - sourced from readGatewayPendingConfigFallback instead of
   * GetGateway's own `gateway.devices`, per KETON-62.
   *
   * TODO: `alarmStatus` has no equivalent in this payload - the status-dot column
   * renders blank until the backend adds it there. modelName/protocolType can also come
   * back null for devices that don't override their type's values (this payload doesn't
   * resolve inherited type fields).
   */
  private refreshGatewayDeviceList(): Promise<void> {
    if (!this.selectedGateway)
      return Promise.resolve();

    const gatewayId = this.selectedGateway.id;
    const cb = new ReadGatewayPendingConfigFallbackCB();
    cb.i.gatewayId = gatewayId;

    return this.gatewayPendingConfigOpeService.readGatewayPendingConfigFallback(cb).then(() => {
      // The user may have switched gateway while the request was in flight
      if (!this.selectedGateway || this.selectedGateway.id !== gatewayId)
        return;

      // Read from the last draft list, not selectedGateway.devices: getGateway() replaces that
      // with the payload's own devices, which carry no changeType
      const openDeviceId = this.selectedDeviceLite?.id;
      const openDeviceBefore = this.lastDraftDevices?.gatewayId === gatewayId
        ? this.lastDraftDevices.devices.find(d => d.id === openDeviceId)
        : undefined;

      this.selectedGateway.devices = cb.o.payload.devices.map(device => this.mapDraftDeviceToLite(device));
      this.lastDraftDevices = {gatewayId, devices: this.selectedGateway.devices};
      this.subscribedNotificationIdsDevices = this.selectedGateway.devices.map(d => d.id);
      this.deviceAlarmNotificationService.addDeviceIdsToAlarmNotifications(this.subscribedNotificationIdsDevices);

      if (openDeviceId !== undefined && !this.selectedGateway.devices.some(d => d.id === openDeviceId))
        this.closeRemovedDeviceDrawer(
          openDeviceBefore?.changeType === ChangeTypeEnum.DELETED,
          openDeviceBefore?.name ?? this.selectedDeviceLite?.name ?? '');
    });
  }

  private lastDraftDevices?: {gatewayId: number, devices: DeviceLite[]};

  /**
   * Reloads the device list, then the open device only if it still exists: loading it first
   * fails with "not found" when its deletion was just applied.
   */
  private refreshGatewayDeviceListAndOpenDevice() {
    this.refreshGatewayDeviceList().then(() => {
      const openDeviceId = this.selectedDeviceLite?.id;
      if (openDeviceId !== undefined && !this.removedDeviceDialogOpen
        && this.lastDraftDevices?.gatewayId === this.selectedGateway?.id
        && this.lastDraftDevices?.devices.some(d => d.id === openDeviceId))
        this.getDevice();
    });
  }

  private removedDeviceDialogOpen = false;

  /**
   * The open device is gone from the reloaded list: either its pending deletion was applied, or
   * its draft was discarded from another session ("revert all" / rollback). It can't be saved
   * anymore, so the drawer closes; the user is told why, and has to acknowledge it if unsaved
   * edits are lost.
   */
  private closeRemovedDeviceDrawer(wasPendingDeletion: boolean, deviceName: string) {
    if (this.removedDeviceDialogOpen)
      return;

    const close = () => {
      this.resetDrawer();
      this.isDeviceOrGatewayDrawerOpen = false;
      this.selectedDeviceTab = 0;
      this.resetDeviceGrid();
      this.cdr.detectChanges();
    };

    if (wasPendingDeletion) {
      this.toastService.openInfoToastMessage(
        this.translate.instant('REGISTRY.DEVICE.TEXT.REMOVED_CONFIG_APPLIED', {deviceName}));
      close();
      return;
    }

    if (!this.isEditMode || !this.deviceEdited) {
      this.toastService.openWarningToastMessage(
        this.translate.instant('REGISTRY.DEVICE.TEXT.DRAFT_DISCARDED', {deviceName}));
      close();
      return;
    }

    this.removedDeviceDialogOpen = true;
    const escapedDeviceName = Object.assign(document.createElement('span'), {textContent: deviceName}).innerHTML;
    custom({
      title: this.translate.instant('REGISTRY.DEVICE.TEXT.DRAFT_DISCARDED_TITLE'),
      messageHtml: this.translate.instant('REGISTRY.DEVICE.TEXT.DRAFT_DISCARDED_UNSAVED', {deviceName: escapedDeviceName}),
      buttons: [
        {
          text: this.translate.instant('BUTTONS.CLOSE'),
          type: 'default',
          stylingMode: 'contained',
          onClick: () => true
        }
      ]
    }).show().then(() => {
      this.removedDeviceDialogOpen = false;
      close();
    });
  }

  private gatewayRefreshRequests = new Map<number, number>();

  /**
   * Re-reads one gateway after a workflow status change. The notification only carries the
   * status, but its changeType, its devices' changeTypes and the actions derived from them can
   * change with it (e.g. the pending config was just applied). Drawer edits are left untouched.
   */
  private refreshGatewayFromServer(gatewayId: number) {
    const request = (this.gatewayRefreshRequests.get(gatewayId) ?? 0) + 1;
    this.gatewayRefreshRequests.set(gatewayId, request);

    const cb = new GetGatewayPayloadCB();
    cb.i.gatewayId = gatewayId;

    this.gatewayPendingConfigOpeService.getGatewayPayload(cb).then(() => {
      if (this.gatewayRefreshRequests.get(gatewayId) !== request)
        return;

      const fresh: Gateway = {...cb.o.gateway, changeType: cb.o.status};
      const serverOwned = {
        macAddress: fresh.macAddress,
        online: fresh.online,
        status: fresh.status,
        updateWorkflowStatusTs: fresh.updateWorkflowStatusTs,
        hasPendingDevice: fresh.hasPendingDevice,
        hasPendingGatewayFields: fresh.hasPendingGatewayFields,
        changeType: fresh.changeType,
      };

      const row = this.gateways.find(g => g.id === gatewayId);
      if (row)
        Object.assign(row, serverOwned, {name: fresh.name});

      if (this.selectedGateway?.id === gatewayId) {
        this.selectedGateway = {...fresh, devices: this.selectedGateway.devices};
        this.selectedGatewayNetConfig = this.parseNetworkConfig(fresh.netConfig);

        // Syncing the fields the user can't edit keeps the form's dirty check (a whole-object
        // compare against selectedGateway) from flagging the status change as an edit.
        if (this.editedGateway?.id === gatewayId) {
          if (this.isEditMode)
            Object.assign(this.editedGateway, serverOwned);
          else
            this.editedGateway = JSON.parse(JSON.stringify(this.selectedGateway));
        }

        this.refreshGatewayDeviceList();
      }

      this.cdr.detectChanges();
    });
  }

  private mapDraftDeviceToLite(device: DeviceDraftDTO): DeviceLite {
    const lite = new DeviceLite();
    lite.id = device.id!;
    lite.name = device.name;
    lite.gatewayId = this.selectedGateway?.id;
    lite.acquisitionCron = device.acquisitionCron;
    lite.alarmStatus = device.alarmStatus;
    lite.changeType = device.changeType;
    lite.type = {
      id: device.typeId,
      modelName: device.modelName!,
      protocolType: device.protocolType!,
      label: device.label || device.modelName!,
    };
    return lite;
  }

  /**
   * Get all devices
   */
  getDevice() {
    const cb = new GetDevicePendingConfigCB();

    cb.i.deviceId = this.selectedDeviceLite!.id;
    cb.i.gatewayId = this.selectedGateway!.id;

    this.gatewayPendingConfigOpeService.getDevicePendingConfig(cb).then((_) => {

      this.selectedDeviceFull = cb.o.device;
      this.stampUiKeys(this.selectedDeviceFull);
      this.deviceCompareGroups = (this.selectedDeviceFull.metricGroupInstances ?? [])
        .map(group => this.mapDeviceGroupToCompareGroup(group));

      if (this.selectedDeviceFull.protocolType === ProtocolTypeEnum.MODBUS_RTU && this.selectedDeviceFull.transportConfiguration) {
        this.selectedDeviceFull.transportConfiguration.combinedField =
          this.selectedDeviceFull.transportConfiguration.dataBits +
          this.selectedDeviceFull.transportConfiguration.parity +
          this.selectedDeviceFull.transportConfiguration.stopBits;
      }

      this.cdr.detectChanges();
      if (this.selectedMetricGroup && this.editedDeviceFull?.metricGroupInstances) {
        this.selectedMetricGroup = this.editedDeviceFull?.metricGroupInstances.find(g => getRowKey(g) === getRowKey(this.selectedMetricGroup));
      }
      this.editedDeviceFull = this.appService.deepCopy(this.selectedDeviceFull);
      // Not while the gateway drawer is open: re-measuring would disrupt it
      if (!this.isGatewayDrawerOpen)
        this.prepareDrawerWidth(true);
      this.isDeviceOrGatewayDrawerOpen = true;
      setTimeout(() => {
        this.editedDeviceFull = this.appService.deepCopy(this.selectedDeviceFull!);
      }, 0)
    });
  }

  /**
   * Save gateway-device (new or update)
   */
  putDevice(device: DeviceDraft) {

    const cb = new SaveDevicePendingConfigCB();

    cb.i.gatewayId = this.selectedGateway!.id;
    cb.i.device = this.mapDeviceDraftToDto(device);

    this.gatewayPendingConfigOpeService.saveDevicePendingConfig(cb).then((_) => {

      this.addDevice = false;

      this.deviceEdited = false;

      this.isNewFormValid = false;

      if (!device.id)
        this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE.TEXT.CREATED"));
      else
        this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE.TEXT.UPDATED"));

      this.resetDrawer();
      this.getDevices();
    }).catch((error) => {

      this.getDevices();
    });
  }

  /**
   * Delete a gateway-device.
   *
   * Uses cancelDevicePendingConfig rather than a hard delete: if the device was only ever
   * DRAFTED (never an official row), the backend hard-deletes it and this behaves like a
   * real delete. If the device is already official (CREATED), the backend does NOT delete
   * it - it only discards any pending draft edits and reverts it to its official state, so
   * it will still show up afterward. The DELETED toast/copy below assumes the former case.
   */
  delDevice(deviceId: number) {
    const cb = new CancelDevicePendingConfigCB();

    cb.i.gatewayId = this.selectedGateway!.id!;
    cb.i.deviceId = deviceId;

    this.gatewayPendingConfigOpeService.cancelDevicePendingConfig(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE.TEXT.DELETED"));

      this.getGateways();

      this.closeDrawer();

    }).catch((_) => {
      this.getGateways();
    });
  }

  /**
   * Open drawer when clicking on a data grid row
   * @param $event
   */
  onGatewayRowClick($event: any) {

    if (!this.selectedGateway) {
      this.selectedGateway = $event.data;
      this.getGateway();
    } else if (this.isGatewayDrawerOpen) {
      if (this.gatewayEdited && this.isEditMode) {
        this.showDiscardEditsDialog().show().done((dialogResult: any) => {
          if (dialogResult) {
            this.resetGatewayDrawer();
            this.isGatewayDrawerOpen = false;
            // this.resetGatewayGrid();

            if (this.selectedGateway!.id !== $event.data.id) {
              this.selectedGateway = $event.data;
              this.getGateway();
            } else {
              this.selectedGateway = undefined;
              this.selectedRowGateway = [];
            }
          } else {
            this.selectedRowGateway = [this.selectedGateway?.id];
          }
        });
      } else {
        this.resetGatewayDrawer();
        this.isGatewayDrawerOpen = false;
        // this.resetGatewayGrid();

        if (this.selectedGateway.id !== $event.data.id) {
          this.selectedGateway = $event.data;
          this.getGateway();
        } else {
          this.selectedGateway = undefined;
          this.selectedRowGateway = [];
        }
      }
    } else if (this.isDeviceOrGatewayDrawerOpen) {
      if (this.deviceEdited && this.isEditMode) {
        this.showDiscardEditsDialog().show().done((dialogResult: any) => {
          if (dialogResult) {
            this.resetDrawer();
            this.isDeviceOrGatewayDrawerOpen = false;
            this.selectedDeviceTab = 0;
            this.resetDeviceGrid();
            this.selectedMetricGroup = undefined;
            this.selectedRowMetricGroup = [];

            if (this.selectedGateway!.id !== $event.data.id) {
              this.selectedGateway = $event.data;
              this.getGateway();
            } else {
              this.selectedGateway = undefined;
              this.selectedRowGateway = [];
            }
          } else {
            this.selectedRowGateway = [this.selectedGateway?.id];
          }
        });
      } else {
        this.resetDrawer();
        this.isDeviceOrGatewayDrawerOpen = false;
        this.selectedDeviceTab = 0;
        this.resetDeviceGrid();
        this.selectedMetricGroup = undefined;
        this.selectedRowMetricGroup = [];

        if (this.selectedGateway.id !== $event.data.id) {
          this.selectedGateway = $event.data;
          this.getGateway();
        } else {
          this.selectedGateway = undefined;
          this.selectedRowGateway = [];
        }
      }
    } else if (this.selectedGateway.id !== $event.data.id) {
      this.selectedGateway = $event.data;
      this.getGateway();
    } else {
      this.selectedGateway = undefined;
      this.selectedRowGateway = [];
    }
  }

  onDeviceRowClick($event: any) {
    if (!this.selectedDeviceLite) {
      this.selectedDeviceLite = $event.data;
      this.getDevice();
    } else if (this.selectedDeviceLite.id === $event.data.id) {
      this.closeDrawer();
    } else {
      this.switchDevice($event.data);
    }
  }

  switchDevice(device: Device) {
    if (this.deviceEdited && this.isEditMode) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
          this.selectedDeviceLite = device;
          this.getDevice();
        } else {
          this.selectedRowDevice = [this.selectedDeviceLite!.id];
        }
      });
    } else {
      this.resetDrawer();
      this.selectedDeviceLite = device;
      this.getDevice();
    }

  }

  /**
   * Template (left column) data for the model/device compare popup. Refetched via
   * getDeviceType whenever the popup's device-type selector changes (including the
   * initial selection when the popup opens - see onCompareDeviceTypeChange).
   */
  templateCompareGroups: CompareGroupVM[] = [];

  /**
   * Local working copy of the device draft while the compare popup is open. All
   * add/replace actions mutate this instead of calling the backend directly -
   * the backend save only happens once, when the user clicks the Save button
   * (see onCompareSave). Cancel just discards it.
   */
  private pendingCompareDraft?: DeviceDraft;

  openTemplateCompare() {
    this.pendingCompareDraft = this.appService.deepCopy(this.selectedDeviceFull!);
    this.templateCompareVisible = true;
  }

  resetDeviceFromModel(deviceTypeId: number) {
    const deviceType = this.deviceTypes.find(dt => dt.id === deviceTypeId);
    const modelName = deviceType?.label ?? deviceType?.modelName ?? '';
    const escapedModelName = Object.assign(document.createElement('span'), {textContent: modelName}).innerHTML;
    const currentReference = this.selectedDeviceFull!.defaultType ?? this.selectedDeviceFull!.typeId;
    const messageKey = deviceTypeId === currentReference
      ? 'REGISTRY.DEVICE.TEMPLATE_IMPORT.CONFIRM_RESET_MESSAGE_CURRENT_REFERENCE'
      : 'REGISTRY.DEVICE.TEMPLATE_IMPORT.CONFIRM_RESET_MESSAGE';
    custom({
      title: this.translate.instant('REGISTRY.DEVICE.TEMPLATE_IMPORT.CONFIRM_RESET_TITLE', {modelName}),
      messageHtml: this.translate.instant(messageKey, {modelName: escapedModelName}),
      buttons: [
        {
          text: this.translate.instant('REGISTRY.DEVICE.TEMPLATE_IMPORT.RESET_BUTTON'),
          icon: 'refresh',
          stylingMode: 'contained',
          type: 'danger',
          onClick: () => true
        },
        {
          text: this.translate.instant('BUTTONS.CANCEL'),
          icon: 'revert',
          type: 'default',
          onClick: () => false
        }
      ]
    }).show().then((confirmed: boolean) => {
      if (!confirmed)
        return;
      const cb = new ResetDeviceFromModelCB();
      cb.i.deviceId = this.selectedDeviceFull!.id!;
      cb.i.deviceTypeId = deviceTypeId;
      this.deviceOpeService.resetDeviceFromModel(cb).then(() => {
        this.toastService.openSuccessToastMessage(this.translate.instant('REGISTRY.DEVICE.TEXT.UPDATED'));
        this.pendingCompareDraft = undefined;
        this.templateCompareVisible = false;
        this.resetDrawer();
        this.getDevices();
      });
    });
  }

  onCompareDeviceTypeChange(deviceTypeId: number) {
    const cb = new GetDeviceTypeCB();
    cb.i.id = deviceTypeId;
    this.deviceTypeOpeService.getDeviceType(cb).then(() => {
      this.templateCompareGroups = this.mapMetricGroupsToCompareGroups(cb.o.deviceType.metricGroups);
    });
  }

  /**
   * Device (right column) data: the device's own group/metric instances, straight off
   * the currently loaded pending-config draft. `metricGroupId`/`metricId` on the draft
   * rows already ARE the origin reference (they're the template group/metric's own PK) -
   * no separate origin_id was ever needed.
   *
   * Computed once in getDevice()'s callback (and cleared in resetDeviceGrid()) rather
   * than as a getter: a getter here re-maps the whole tree on every change-detection
   * cycle app-wide (the compare popup component stays mounted whenever a device is
   * selected, even while its dialog is closed), which was making the Misure tab feel
   * sluggish.
   */
  deviceCompareGroups: CompareGroupVM[] = [];

  /**
   * DevExtreme's `keyExpr` grid input only accepts a field name, not a lookup function -
   * so every group/metric row needs a real, always-defined `_uiKey` string to key off of.
   * Freshly-added rows get one at creation time (see onCompareAddGroup/onCompareAddMetric);
   * this backfills it for rows freshly loaded from the backend (which always have a real
   * `id`, just no `_uiKey` yet).
   */
  private stampUiKeys(draft: DeviceDraft) {
    for (const group of draft.metricGroupInstances ?? []) {
      group._uiKey ??= String(group.id);
      for (const metric of group.metrics ?? [])
        metric._uiKey ??= String(metric.id);
    }
  }

  private mapDeviceGroupToCompareGroup(group: MetricGroupInstanceDraft): CompareGroupVM {
    return {
      id: group.id!,
      originId: group.metricGroupId,
      name: group.name ?? '',
      transportConfiguration: group.transportConfiguration,
      isWritableOnEdge: group.isWritableOnEdge,
      metrics: (group.metrics ?? []).map(metric => this.mapDeviceMetricToCompareMetric(metric)),
      _uiKey: group._uiKey
    };
  }

  private mapDeviceMetricToCompareMetric(metric: MetricInstanceDraft): CompareMetricVM {
    return {
      id: metric.id!,
      originId: metric.metricId,
      name: metric.name ?? '',
      dataUnitId: metric.dataUnitId,
      divider: metric.divider,
      decimalDigits: metric.decimalDigits,
      transportConfiguration: metric.transportConfiguration,
      selected: metric.selected,
      _uiKey: metric._uiKey
    };
  }

  onCompareAddGroup(group: CompareGroupVM) {
    const draft = this.pendingCompareDraft!;
    const newGroup: MetricGroupInstanceDraft = {
      id: undefined,
      metricGroupId: group.id,
      name: group.name,
      metricOffset: 0,
      transportConfiguration: group.transportConfiguration,
      isWritableOnEdge: group.isWritableOnEdge ?? false,
      metrics: group.metrics.map(metric => ({
        id: undefined,
        metricId: metric.id,
        selected: true,
        name: metric.name,
        divider: metric.divider,
        decimalDigits: metric.decimalDigits,
        dataUnitId: metric.dataUnitId,
        transportConfiguration: metric.transportConfiguration,
        _uiKey: uuid.v4()
      })),
      _uiKey: uuid.v4()
    };
    draft.metricGroupInstances.push(newGroup);
    this.refreshPendingCompareGroups();
  }

  onCompareAddMetric(payload: { group: CompareGroupVM, metric: CompareMetricVM }) {
    const draft = this.pendingCompareDraft!;
    const targetGroup = draft.metricGroupInstances.find((g: MetricGroupInstanceDraft) => getRowKey(g) === getRowKey(payload.group));
    if (!targetGroup)
      return;
    targetGroup.metrics.push({
      id: undefined,
      metricId: payload.metric.id,
      selected: true,
      name: payload.metric.name,
      divider: payload.metric.divider,
      decimalDigits: payload.metric.decimalDigits,
      transportConfiguration: payload.metric.transportConfiguration,
      dataUnitId: payload.metric.dataUnitId,
      _uiKey: uuid.v4()
    });
    this.refreshPendingCompareGroups();
  }

  onCompareReplaceMetric(payload: { group: CompareGroupVM, metric: CompareMetricVM }) {
    const draft = this.pendingCompareDraft!;
    const targetGroup = draft.metricGroupInstances.find((g: MetricGroupInstanceDraft) => getRowKey(g) === getRowKey(payload.group));
    const targetMetric = targetGroup?.metrics.find((m: MetricInstanceDraft) => m.metricId === payload.metric.id);
    if (!targetMetric)
      return;
    targetMetric.name = payload.metric.name;
    targetMetric.divider = payload.metric.divider;
    targetMetric.decimalDigits = payload.metric.decimalDigits;
    targetMetric.transportConfiguration = payload.metric.transportConfiguration;
    targetMetric.dataUnitId = payload.metric.dataUnitId;
    this.refreshPendingCompareGroups();
  }

  onCompareDeleteGroup(group: CompareGroupVM) {
    const draft = this.pendingCompareDraft!;
    draft.metricGroupInstances = draft.metricGroupInstances.filter((g: MetricGroupInstanceDraft) => getRowKey(g) !== getRowKey(group));
    this.refreshPendingCompareGroups();
  }

  onCompareDeleteMetric(payload: { group: CompareGroupVM, metric: CompareMetricVM }) {
    const draft = this.pendingCompareDraft!;
    const targetGroup = draft.metricGroupInstances.find((g: MetricGroupInstanceDraft) => getRowKey(g) === getRowKey(payload.group));
    if (!targetGroup)
      return;
    targetGroup.metrics = targetGroup.metrics.filter((m: MetricInstanceDraft) => getRowKey(m) !== getRowKey(payload.metric));
    this.refreshPendingCompareGroups();
  }

  private refreshPendingCompareGroups() {
    this.deviceCompareGroups = (this.pendingCompareDraft!.metricGroupInstances ?? [])
      .map(group => this.mapDeviceGroupToCompareGroup(group));
  }

  /**
   * Explicit field-by-field mapper for the pending-config save payload - deliberately
   * does NOT spread/reuse the draft object as-is, so FE-only fields (`_uiKey`,
   * `showInvalidBadge`) never ride along into the request. Mirrors the pattern
   * device-type.component.ts's mapDeviceTypeToCB already uses for the same reason.
   */
  private mapDeviceDraftToDto(draft: DeviceDraft): DeviceDraftDTO {
    const dto = new DeviceDraftDTO();
    dto.id = draft.id;
    dto.name = draft.name;
    dto.typeId = draft.typeId;
    dto.transportConfiguration = draft.transportConfiguration;
    dto.acquisitionCron = draft.acquisitionCron;
    dto.modelName = draft.modelName;
    dto.partNumber = draft.partNumber;
    dto.protocolType = draft.protocolType;
    dto.manufacturerId = draft.manufacturerId;
    dto.modbusWritePauseMillis = draft.modbusWritePauseMillis;
    dto.defaultType = draft.defaultType;
    dto.metricGroupInstances = (draft.metricGroupInstances ?? []).map(group => {
      const groupDto = new MetricGroupInstanceDraftDTO();
      groupDto.id = group.id;
      groupDto.metricGroupId = group.metricGroupId;
      groupDto.name = group.name;
      groupDto.metricOffset = group.metricOffset;
      groupDto.transportConfiguration = group.transportConfiguration;
      groupDto.isWritableOnEdge = group.isWritableOnEdge;
      groupDto.metrics = (group.metrics ?? []).map(metric => {
        const metricDto = new MetricInstanceDraftDTO();
        metricDto.id = metric.id;
        metricDto.metricId = metric.metricId;
        metricDto.selected = metric.selected;
        metricDto.name = metric.name;
        metricDto.divider = metric.divider;
        metricDto.decimalDigits = metric.decimalDigits;
        metricDto.transportConfiguration = metric.transportConfiguration;
        metricDto.dataUnitId = metric.dataUnitId;
        metricDto.wm2eOriginType = metric.wm2eOriginType;
        metricDto.wm2eOriginId = metric.wm2eOriginId;
        metricDto.wm2eOrigin = metric.wm2eOrigin;
        return metricDto;
      });
      return groupDto;
    });
    return dto;
  }

  onCompareSave(payload: {useAsReferenceType: boolean, selectedDeviceTypeId?: number}) {
    const draft = this.pendingCompareDraft!;

    // "Set as reference model" only actually changes defaultType if the user ends up on a
    // different type than the one the field already pointed to (or, absent a defaultType,
    // the device's own typeId) - flipping the switch on without changing the selection is a
    // no-op, matching applyDefaultTypeImmediately's "null means leave untouched" contract.
    const previousDefaultType = draft.defaultType ?? draft.typeId;
    if (payload.useAsReferenceType && payload.selectedDeviceTypeId !== undefined
      && payload.selectedDeviceTypeId !== previousDefaultType) {
      draft.defaultType = payload.selectedDeviceTypeId;
    }

    const cb = new SaveDevicePendingConfigCB();
    cb.i.gatewayId = this.selectedGateway!.id!;
    cb.i.device = this.mapDeviceDraftToDto(draft);
    this.gatewayPendingConfigOpeService.saveDevicePendingConfig(cb).then(() => {
      this.pendingCompareDraft = undefined;
      this.templateCompareVisible = false;
      this.getDevice();
      this.getDevices();
    });
  }

  onCompareCancel() {
    this.pendingCompareDraft = undefined;
    this.templateCompareVisible = false;
    this.deviceCompareGroups = (this.selectedDeviceFull?.metricGroupInstances ?? [])
      .map(group => this.mapDeviceGroupToCompareGroup(group));
  }

  private mapMetricGroupsToCompareGroups(metricGroups: MetricGroup[] | undefined): CompareGroupVM[] {
    return (metricGroups ?? []).map(group => ({
      id: group.id!,
      name: group.name ?? '',
      transportConfiguration: group.transportConfiguration,
      isWritableOnEdge: group.isWritableOnEdge,
      // Template groups/metrics always have a real backend id (they're never "new" in
      // this flow) - mirrored into _uiKey so the grid's keyExpr (a plain field name,
      // can't be a lookup function) has something to key off of.
      _uiKey: String(group.id),
      metrics: (group.metrics ?? []).map((metric: any) => ({
        id: metric.id,
        name: metric.name,
        dataUnitId: metric.dataUnit?.id,
        divider: metric.divider,
        decimalDigits: metric.decimalDigits,
        transportConfiguration: metric.transportConfiguration,
        _uiKey: String(metric.id)
      }))
    }));
  }

  /**
   * Enable form edit in drawer
   */
  enableEditModeDevice() {
    this.isEditMode = true;
    this.updateDeviceTextOptions();
    this.cdr.detectChanges();
    if (this.selectedDeviceFull) {
      this.editedDeviceFull = this.appService.deepCopy(this.selectedDeviceFull);
      this.editedDeviceFull = this.appService.deepCopy(this.selectedDeviceFull);
    }
    if (!!this.selectedMetricGroup && this.editedDeviceFull?.metricGroupInstances) {
      this.selectedMetricGroup = this.editedDeviceFull?.metricGroupInstances.find(g => g.id === this.selectedMetricGroup!.id);
    }
  }

  /**
   * Disable form edit in drawer
   */
  disableEditModeDevice() {
    if (this.deviceEdited) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
        }
      });
    } else {
      this.resetDrawer();
    }
  }

  async saveDevice() {

    if (this.editDeviceFormComponent.editDeviceForm) {
      const validation = this.editDeviceFormComponent.editDeviceForm.instance.validate();
      if (!validation.isValid) {
        this.isEditFormValid = validation.isValid;
        return;
      }
    }

    // A row left "in modifica" in the metrics tab was never confirmed into the bound data and
    // would be dropped silently by the save - warn before that happens.
    if (this.editDeviceFormComponent.rowStateTrackers.some(t => t.hasEditing())) {
      const proceed = await this.showSaveWithPendingEditDialogWithPromise();
      if (!proceed) return;
      this.editDeviceFormComponent.cancelActiveRowEdits();
    }

    if (this.editedDeviceFull!.protocolType === "MODBUS_RTU") {
      this.editedDeviceFull!.transportConfiguration!.dataBits = Number(this.editedDeviceFull!.transportConfiguration?.combinedField?.charAt(0));
      this.editedDeviceFull!.transportConfiguration!.parity = this.editedDeviceFull!.transportConfiguration?.combinedField?.charAt(1)!;
      this.editedDeviceFull!.transportConfiguration!.stopBits = Number(this.editedDeviceFull!.transportConfiguration?.combinedField?.charAt(2));
    }
    // isEditMode only clears on success, via resetDrawer() inside putDevice()'s .then() -
    // don't clear it here, or a failed save silently drops out of edit mode too.
    this.putDevice(this.editedDeviceFull!);
  }

  /**
   * Update form fields when enabling/disabling edit mode
   */
  updateDeviceTextOptions() {

    this.deviceEditTextOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode
    };

    this.deviceEditTextAreaOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode,
      autoResizeEnabled: true
    };

    this.deviceEditNumberOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode,
      mode: 'number'
    };

    this.deviceEditCheckBoxOptions = {
      disabled: !this.isEditMode
    }
  }


  /**
   * Call delDevice
   */
  deleteDevice() {
    this.deletingDevice = false;
    this.delDevice(this.selectedDeviceLite!.id);
  }

  /**
   * Close lateral drawer
   */
  closeDrawer() {
    if (this.isGatewayDrawerOpen) {
      this.closeGatewayDrawer();
    } else if (this.deviceEdited && this.isEditMode) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
          this.isDeviceOrGatewayDrawerOpen = false;
          this.selectedDeviceTab = 0;
          this.resetDeviceGrid();
        }
      });
    } else {
      this.resetDrawer();
      this.isDeviceOrGatewayDrawerOpen = false;
      this.selectedDeviceTab = 0;
      this.resetDeviceGrid();
    }
  }

  resetDeviceGrid() {
    this.selectedDeviceLite = undefined;
    this.selectedDeviceFull = undefined;
    this.editedDeviceFull = new DeviceDraft();
    this.selectedRowDevice = [];
    this.deviceCompareGroups = [];
  }

  /**
   * Reset all drawer vars
   */
  resetDrawer() {
    this.isEditMode = false;
    this.updateDeviceTextOptions();
    this.cdr.detectChanges();
    if (this.selectedDeviceFull) {
      this.editedDeviceFull = JSON.parse(JSON.stringify(this.selectedDeviceFull));
    }
    this.cdr.detectChanges();
    this.deviceEdited = false;
    this.selectedRowMetricGroup = undefined;
    this.selectedMetricGroup = undefined;
    if (this.editDeviceFormComponent) {
      this.editDeviceFormComponent.resetRowStates();
      this.editDeviceFormComponent.resetForm();
    }
  }

  closeGatewayDrawer() {
    if (this.gatewayEdited && this.isEditMode) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetGatewayDrawer();
          this.isGatewayDrawerOpen = false;
          this.selectedGatewayTab = 0;
        }
      });
    } else {
      this.resetGatewayDrawer();
      this.isGatewayDrawerOpen = false;
      this.selectedGatewayTab = 0;
    }

  }

  /**
   * Show new gateway form
   */
  showNewDeviceForm() {
    this.newDevice = new DeviceDraft();

    if (!!this.selectedPartitionId || this.selectedPartitionId === 0) {
      this.selectedRowPartitionNewGatewayForm = [this.selectedPartitionId];
      this.newDevice.partitionId = this.selectedPartitionId;
    }
    this.addDevice = true;
  }

  override setWidthOfDrawerPx(): number {
    if (this.isMobile) {
      return document.documentElement.clientWidth;
    } else if (this.isSmallScreen) {
      return document.documentElement.clientWidth * 0.8;
    } else if (this.compactDrawerWidth) {
      return document.documentElement.clientWidth * GatewayDeviceComponent.COMPACT_DRAWER_VIEWPORT_RATIO;
    } else {
      return document.documentElement.clientWidth * 0.45;
    }
  }

  parseNetworkConfig(jsonData: any) {
    let netConfig = JSON.parse(jsonData);
    if (jsonData)
      return Object.keys(netConfig).map(key => new NetConfig(key, netConfig[key]));
    else
      return [];
  }

  /**
   * Add or update a gateway
   */
  putGateway(gateway: Gateway) {

    // Creation goes through putGatewayLegacy, a direct insert in the database: the new
    // gateway is FLASHED, nothing is configured on the edge yet, so there is no
    // asynchronism to handle and no reason to park it in the pending-config draft.
    if (!gateway.id) {
      const legacyCb = new PutGatewayLegacyCB();

      legacyCb.i.partitionId = gateway.partitionId!;
      legacyCb.i.name = gateway.name!;
      legacyCb.i.typeId = gateway.type?.id!;
      legacyCb.i.sendingCron = gateway.sendingCron!;
      legacyCb.i.macAddress = gateway.macAddress;

      this.gatewayService.putGatewayLegacy(legacyCb).then((_) => {

        this.onPutGatewaySuccess(true);

        // reload partitions list
        if (!!this.selectedPartitionId || this.selectedPartitionId === 0)
          this.getGateways(legacyCb.o.id);

      }).catch((_) => this.onPutGatewayError());

      return;
    }

    // Update: only proposes the change in the pending-config draft, applied on confirm.
    const cb = new PutGatewayCB();

    cb.i.id = gateway.id;
    cb.i.name = gateway.name!;
    cb.i.typeId = gateway.type?.id!;
    cb.i.sendingCron = gateway.sendingCron!;
    cb.i.macAddress = gateway.macAddress;

    this.gatewayService.putGateway(cb).then((_) => {

      this.onPutGatewaySuccess(false);

      // reload partitions list
      if (!!this.selectedPartitionId || this.selectedPartitionId === 0)
        this.getGateways();

    }).catch((_) => this.onPutGatewayError());

  }

  private onPutGatewaySuccess(created: boolean) {
    this.addGateway = false;

    this.isNewFormValid = false;

    this.toastService.openSuccessToastMessage(this.translate.instant(
      created ? "REGISTRY.GATEWAY.TEXT.CREATED" : "REGISTRY.GATEWAY.TEXT.UPDATED"));

    this.resetGatewayDrawer();
  }

  private onPutGatewayError() {
    // reload partitions list
    if (!!this.selectedPartitionId || this.selectedPartitionId === 0)
      this.getGateways();
  }

  /**
   * Enable form edit in drawer
   */
  enableEditModeGateway() {
    this.isEditMode = true;
    this.updateGatewayTextOptions();
  }

  /**
   * Disable form edit in drawer
   */
  disableEditModeGateway() {
    if (this.gatewayEdited && this.isEditMode) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetGatewayDrawer();
        }
      });
    } else {
      this.resetGatewayDrawer();
    }
  }

  saveGateway() {
    // isEditMode only clears on success, via resetGatewayDrawer() inside putGateway()'s
    // .then() - don't clear it here, or a failed save silently drops out of edit mode too.
    this.putGateway(this.editedGateway!);
  }

  /**
   * Update form fields when enabling/disabling edit mode
   */
  updateGatewayTextOptions() {

    this.gatewayEditTextOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode
    };

    this.gatewayEditTextAreaOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode,
      autoResizeEnabled: true
    };

    this.gatewayEditNumberOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode,
      mode: 'number'
    };

    this.gatewayEditCheckBoxOptions = {
      disabled: !this.isEditMode
    }
  }

  /**
   * Ope to delete a gateway
   */
  deleteGateway() {

    // close delete gateway dialog
    this.deletingGateway = false;

    // create cb
    const cb: DelGatewayCB = new DelGatewayCB();
    cb.i.id = this.selectedGateway!.id;

    // call ope
    this.gatewayService.delGateway(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.GATEWAY.TEXT.DELETED"));
      this.getGateways();
      this.isGatewayDrawerOpen = false;
      this.isDeviceOrGatewayDrawerOpen = false;
      this.selectedGateway = undefined;
    });
  }


  resetGatewayGrid() {
    this.selectedGateway = undefined;
    this.editedGateway = undefined;
    this.selectedRowGateway = [];
  }

  /**
   * Reset all drawer vars
   */
  resetGatewayDrawer() {
    if (this.selectedGateway) {
      this.editedGateway = JSON.parse(JSON.stringify(this.selectedGateway));
    }
    this.gatewayEdited = false;
    this.isEditMode = false;
    this.updateGatewayTextOptions();
  }

  getNetInterfacePasswordGateway() {
    // create cb
    const cb: GetNetInterfacePasswordCB = new GetNetInterfacePasswordCB();
    cb.i.id = this.selectedGateway!.id;

    // call ope
    this.gatewayService.getNetInterfacePassword(cb).then((_) => {
      if (cb.o.password) {
        navigator.clipboard.writeText(cb.o.password).then(
          () => {
            this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.GATEWAY.PASSWORD_COPIED"));
          }
        );
      } else {
        this.toastService.openErrorToastMessage(this.translate.instant("REGISTRY.GATEWAY.PASSWORD_NOT_SET"));
      }
    });
  }


  /**
   * Show new gateway form
   */
  showNewGatewayForm() {
    this.newGateway = new Gateway();

    if (this.selectedPartitionId) {
      this.selectedRowPartitionNewGatewayForm = [this.selectedPartitionId];
      this.newGateway.partitionId = this.selectedPartitionId;
    }
    this.addGateway = true;
  }

  openEditGatewayDrawer(data: Gateway) {

    if (!this.isDeviceOrGatewayDrawerOpen || !this.deviceEdited) {
      if (!this.selectedGateway || (this.selectedGateway.id === data.id && !this.isGatewayDrawerOpen)) {
        this.selectedDeviceLite = undefined;
        this.selectedDeviceFull = undefined;
        this.selectedGateway = data;
        this.getGateway(true);
        // this.isGatewayDrawerOpen = true;
        this.selectedRowGateway = [this.selectedGateway.id];
      } else if (this.selectedGateway.id !== data.id) {
        if (this.isGatewayDrawerOpen && this.gatewayEdited) {
          this.showDiscardEditsDialog().show().done((dialogResult: any) => {
            if (dialogResult) {
              this.resetGatewayDrawer();
              this.selectedDeviceLite = undefined;
              this.selectedDeviceFull = undefined;
              // this.isGatewayDrawerOpen = false;
              // this.resetGatewayGrid();

              this.selectedGateway = data;
              this.selectedRowGateway = [this.selectedGateway.id];
              this.getGateway(true);
            } else {
              this.selectedRowGateway = [this.selectedGateway?.id];
            }
          });
        } else {
          this.resetGatewayDrawer();
          this.selectedDeviceLite = undefined;
          this.selectedDeviceFull = undefined;
          this.selectedGateway = data;
          this.getGateway(true);
          // this.isGatewayDrawerOpen = true;
          this.selectedRowGateway = [this.selectedGateway.id];
        }
      }
    } else if (this.isDeviceOrGatewayDrawerOpen) {
      if (this.deviceEdited && this.isEditMode) {
        this.showDiscardEditsDialog().show().done((dialogResult: any) => {
          if (dialogResult) {
            this.resetDrawer();
            this.isDeviceOrGatewayDrawerOpen = false;
            this.selectedDeviceTab = 0;
            this.resetDeviceGrid();
            this.selectedMetricGroup = undefined;
            this.selectedRowMetricGroup = [];

            this.resetDrawer();
            this.selectedDeviceLite = undefined;
            this.selectedDeviceFull = undefined;
            this.selectedGateway = data;
            this.getGateway(true);
            // this.isGatewayDrawerOpen = true;
            this.selectedRowGateway = [this.selectedGateway.id];
          } else {
            this.selectedRowGateway = [this.selectedGateway?.id];
          }
        });
      } else {
        this.resetDrawer();
        this.isDeviceOrGatewayDrawerOpen = false;
        this.selectedDeviceTab = 0;
        this.resetDeviceGrid();
        this.selectedMetricGroup = undefined;
        this.selectedRowMetricGroup = [];

        this.resetDrawer();
        this.selectedDeviceLite = undefined;
        this.selectedDeviceFull = undefined;
        this.selectedGateway = data;
        this.getGateway(true);
        // this.isGatewayDrawerOpen = true;
        this.selectedRowGateway = [this.selectedGateway.id];
      }
    }
  }

}
